import { formatLocalDate } from '@/utils/localDateUtils';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FactorReajuste } from '@/types';
import adjustmentService from '@/services/adjustmentService';
import DataTable, { Column } from '@/components/common/DataTable';
import MainLayout from '@/components/layout/MainLayout';

export default function AdjustmentFactorList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState<FactorReajuste[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await adjustmentService.getAdjustmentFactors();
        const items = res.data || [];
        setRows(Array.isArray(items) ? items : []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const monthNames = [
    '', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  const columns: Column<FactorReajuste>[] = [
    {
      key: 'anio',
      label: 'Año',
      sortable: true,
    },
    {
      key: 'mes',
      label: 'Mes',
      sortable: true,
      render: (factor) => monthNames[factor.mes] || factor.mes
    },
    {
      key: 'valor',
      label: 'Valor (%)',
      sortable: true,
      render: (factor) => {
        const percentage = (Number(factor.valor) * 100).toFixed(2);
        return (
          <span className="font-semibold text-blue-600">
            {percentage}%
          </span>
        );
      }
    },
    {
      key: 'created_at',
      label: 'Fecha Registro',
      render: (factor) => factor.created_at ? formatLocalDate(factor.created_at) : '-'
    }
  ];

  const handleRowClick = (factor: FactorReajuste) => {
    navigate(`/adjustments/${factor.id}`);
  };

  return (
    <MainLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Factores de Reajuste</h1>
            <p className="text-gray-600 mt-1">Cada factor corresponde a los contratos que vencen en el mes y año indicados.</p>
          </div>
          <button
            onClick={() => navigate('/adjustments/new')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Nuevo Factor
          </button>
        </div>

        <DataTable
          columns={columns}
          data={rows}
          loading={loading}
          searchable={true}
          searchPlaceholder="Buscar por año, mes..."
          searchFields={['anio', 'mes']}
          onRowClick={handleRowClick}
          rowKey="id"
          emptyState={
            <div className="text-center py-12">
              <div className="text-6xl mb-4">📈</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No hay factores de reajuste</h3>
              <p className="text-gray-600 mb-4">Comienza agregando los índices de ajuste mensuales</p>
              <button
                onClick={() => navigate('/adjustments/new')}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Agregar Factor
              </button>
            </div>
          }
        />
      </div>
    </MainLayout>
  );
}



